export default {
    blanks: '---',
    rit: ' RIT',
    space: '\u00a0',
    plusOrMinus: '\u00B1',
    nbsp: '\u00A0',
    collapse: '\u00D7',
    tabHelp: {
        tabColorText:
            "Tab color shows how the student's RIT score ranks against similar students in the NWEA norms study: ",
        priorTermText:
            '* An asterisk indicates a score from a prior term.  Occurs if you chose Most Recent but there is no valid score in the current term.',
        percentageText: 'Percentage and impact of Rapid-Guessing shows the extent of rapid guessing during this test. ',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=639',
        helpLinkText: 'More on this ',
    },
    batchPrint: {
        printStatus: {
            success: 'success',
            failure: 'failure',
        },
    },
    batchPrintSubjectsHelp: {
        initialText: 'Looking for a course that is not in this list?',
        textEnd:
            'Course-specific assessment results are not currently available in Student Profile or Family Report. Please use Class Report or Achievement Status and Growth Report.',
        goToClassReport: 'Go to Class Report',
    },
    comparisonsHelp: {
        initialText:
            'Share with your student how they compare to peers taking MAP Growth, along with how they are projected to perform on other assessments, if that data is available. Open the expanded view',
        initialTextEnd: 'for details and more comparisons.',
    },
    comparisonsExpandedHelp: {
        initialText:
            'Share with your student how they compare to peers taking MAP Growth, along with how they are projected to perform on other assessments, if that data is available.',
    },
    comparisonsReadabilityMeasuresHelp: {
        initialText:
            'The Lexile® Framework for Reading is used to engage students in reading materials that help accelerate their skills. Reading materials in a range 100L below to 50L above their reported Lexile measure will provide an ideal level of challenge while maintaining comprehension.',
    },
    comparisonsMathabilityMeasuresHelp: {
        initialText:
            'The Quantile® Framework for Mathematics helps you personalize math learning for students by linking assessment to instruction. Quantile measures range from below 0Q to above 1400Q and span the skills and concepts taught in kindergarten through high school.',
    },
    comparisonsProjectionsNoProjectionsHelp: {
        initialText:
            'Depending on the state, projections could be limited to certain subjects (typically reading and math) and certain grades (typically 2 through 8).',
        secondParagraph: 'College readiness projections are limited to grades 5 through 10.',
    },
    noValueReported: 'No value reported',
    comparisonsProjectionsLinkingStudy: 'LINKING STUDY',
    comparisonsProjectionsProjectedResults: 'Projected result for tests',
    comparisonsProjectionsRoadToCollege: 'MAPPING THE ROAD TO COLLEGE',
    comparisonsProjectionsCollegeExplorerLink: {
        target: 'https://www.nwea.org/research-data-galleries/mapping-the-road-to-college/',
        displayText: 'COLLEGE EXPLORER TOOL',
    },
    comparisonsGrowthAndAchievement: {
        normPercentileHeader: 'Norms Percentile',
        userNormPercentileHeader: 'User Norms\u00B9 Percentile',
    },
    comparisonsProjectionsNotAvailable: 'No projections available',
    comparisonsConditionalGrowthIndex: 'Conditional Growth Index',
    comparisonsGrowthNoResult: '- -',
    comparisonsConditionalGrowthLink: {
        displayText: 'Watch a short video to learn more about Conditional Growth',
        target: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=643',
    },
    comparisonsExpandedGrowthDescriptionLink: {
        displayText: 'Learn why this is important, and view examples',
        target: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=642',
    },
    comparisonsGrowthFromStartOfTerm: 'From start of term',
    comparisonsGrowthTermEnd: 'End of term',
    comparisonsGrowthPreviousGrowthEventRequired: 'Previous growth tests are needed to view all information.',
    comparisonsGrowthDropdownLabel: 'Comparison Period: ',
    getReadabilityDescription: (studentFirstName) =>
        `These are measures of reading material text complexity. Consider ${studentFirstName}’s age and interests when using these measures to select books for ${studentFirstName} to read.`,
    getMathabilityDescription: (studentFirstName) =>
        `Quantile measures help match students to their “optimal” challenge. For optimal learning and growth, ${studentFirstName} should practice mathematics within a Quantile range of 50Q above and 50Q below their Quantile measure.`,
    getCollegeExplorerDescription: (studentFirstName) =>
        `See where ${studentFirstName}’s MAP Growth scores can take them.`,
    getConditionalGrowthDescription: (studentFirstName, studentConditionalGrowthDescriptor) =>
        `0.00 being average growth, ${studentFirstName} grew ${studentConditionalGrowthDescriptor} their matching peers.`,
    coverPage: {
        familyReport: 'Family Report',
        summaryTitleBatchPrint: 'Batch PDF Summary',
        pageOverview: 'Student Profile overview',
        pageComparisons: 'Comparisons',
        pageInstructionalAreas: 'Instructional Areas',
        pageGrowthGoals: 'Growth Goals',
        pageSkills: 'Skills',
        studentOptionWithNoTestEvents: 'Include students and subjects without test events',
        studentOptionWithoutNoTestEvents: 'Do not include students and subjects without test events*',
        twoSidedPageBreaks: 'Include 2-sided page breaks',
        subjects: 'Subjects',
        pages: 'Pages',
        students: 'Students',
    },
    familyReportHeader: {
        title: 'Family Report',
        whatIsThisReport: 'What is this report?',
        whatIsThisReportContent:
            'A summary of how your child is performing academically, as measured by the most recent MAP Growth test.',
        whatIsMap: 'What is MAP Growth?',
        whatIsMapContent:
            "A test that adapts to your child's responses in real time to measure your child's skill level.",
        whyIsMyChildTaking: 'Why is my child taking MAP Growth?',
        whyIsMyChildTakingContent:
            'MAP Growth scores help teachers check student performance by measuring Achievement and Growth. Teachers use results to tailor classroom lessons and to set goals for students.',
        whatDoAchievementAndGrowthMean: 'What do Achievement and Growth mean?',
        achievement: 'Achievement',
        achievementContent:
            'How well your child has learned skills in a subject compared to similar students nationwide.*',
        growth: 'Growth',
        growthContent: "A measure of your child's personal progress over the year.",
        whatIsRITScore: 'What is a RIT score?',
        whatIsRITScoreContent:
            'The overall score for a subject based on a Rasch unit (RIT) scale that indicates how your child performed in a subject.',
        similarStudentsAsterisk:
            '*Similar students \u2014 kids with same starting RIT score, same number of weeks of instruction, and in the same grade',
    },
    familyReportFooter: {
        howCanThisInfoHelpMyChild: 'How can I use this information to help my child?',
        talkToTeacherHereAreQuestions: `Talk to your child’s teacher. Here are some questions you can ask:`,
        questionList: [
            'What types of strategies are the teachers using that I may be able to reinforce at home?',
            'Does my child need extra help in any specific areas?',
            `How can I help my child’s academic growth from home?`,
            `How do you measure my child’s learning in your classroom?`,
            `When will my child’s progress be measured again, and when can I get an update on my child’s academic growth?`,
            'How is my child doing in comparison to grade-level expectations?',
            'What will my child be working on to continue growing or to grow towards a mastery of grade-level standards?',
        ],
        whereCanIGetMoreInfo: 'Where can I get more information?',
        checkoutMoreInfo: {
            start: 'Check out',
            url: 'https://nwea.org/familytoolkit/',
            end: 'for more information on MAP Growth, how it works, what it measures, and FAQs.',
        },
        sampleTests: {
            start: 'For sample tests in all subjects, visit',
            url: 'https://warmup.nwea.org/',
            end: '.',
        },
        printedBy: 'Printed by:',
        onDate: 'on',
        confidentialityNotice:
            'CONFIDENTIALITY NOTICE: This information may be confidential and legally protected from disclosure.',
        userNormsFooter: (courseName = '') => {
            return `\u00B9Average Achievement is based on the group of students who have taken MAP Growth ${courseName} tests.`;
        },
    },
    familyReportGrowthRainbow: {
        average: 'Average: 50th',
        noGrowthDataToShow: 'No growth data to show.',
    },
    familyReportAchievementChart: {
        noAchievementDataToShow: 'No achievement data to show.',
    },
    familyReportSubjectSection: {
        achievement: 'Achievement',
        average: 'Average',
        graders: 'graders',
        growth: 'Growth',
        high: 'High',
        ifTakenIn: 'if taken in',
        isInThe: 'is in the',
        isLikelyToBe: 'is likely to be',
        kindergartners: 'kindergartners',
        low: 'Low',
        noGrowthNoTest:
            'A percentile cannot be provided. No comparative data is available for this subject and grade level.',
        noGrowthSingleTest:
            "Your child's growth information will show here when they have scores for an additional term.",
        noStudiesKey: 'NoLinkingStudies',
        ofTheirPeers: 'of their peers.',
        onARangeOf: 'on a range of',
        onThe: 'on the',
        overallRitScore: 'overall score (RIT score) was a',
        percentileMadeMoreProgress: 'percentile, which means they made more progress than',
        percentileName: 'Percentile',
        percentileScoredBetter: (pastTermPhrase) =>
            `percentile${pastTermPhrase ? ' ' + pastTermPhrase : ''}, which means they scored better than`,
        yourChildTenseIn: (isCurrent) => `Your child ${isCurrent ? 'is' : 'was'} in the`,
        pastTermPhrase: (pastGradeDisplayName, pastTermDisplayName) =>
            `of ${pastGradeDisplayName} in the ${pastTermDisplayName}`,
        pastTermDisplayText: (season, year) => `${season} of ${year}`,
        yourChildsGrowth: "Your child's growth from",
    },
    studentConditionalGrowthDescriptor: {
        moreThan: 'more than',
        lessThan: 'less than',
        equal: 'the same as',
    },
    noTestEvents: 'There are no previous test scores for this student.',
    instructionalAreasHelp: {
        initialText:
            'Celebrate your student’s strengths and suggest where to focus efforts within these areas, known as “goal performance” on other reports. Strengths and focus areas are chosen relative to the whole subject score, plus or minus standard error.',
        readMoreText: 'Read More: ',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=646',
        helpLinkText: 'Instructional Areas and Learning Paths',
    },
    noLearningStatementsForStudentWithFiltersApplied: 'There are no Learning Statements for this Instructional Area',
    noStatementsForTest: 'There are no learning statements for this test.',
    noSkillsDataForStudent: 'There is no skill data existing for this student in this subject.',
    nextTermNotSetMessage:
        'The next academic year must be set up before goals can be set.  Ask a leader to add the next year within the MAP preferences.',
    noPreviousGoalsForStudent: 'There are no previous goals for this student.',
    growthHelp: {
        initialText:
            'Create a target goal for each student and track if the student meets the goal. To set or edit a goal, start by clicking the expansion arrows—',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=644',
        helpText: ' Tips for Setting Growth Goals ',
        readMoreText: 'Read More: ',
    },
    quadrantChartHelp: {
        initialText:
            'Use this chart to see how the combination of Growth and Achievement tells a story. Ideally, all students would be in the green quadrant (High Growth and Achievement), and not the red (Low) quadrant. For a student in the orange quadrant (High Growth, Low Achievement), you can encourage continued growth to catch up with peers. For a student in the yellow quadrant (Low Growth, High Achievement), you can encourage even more challenges to keep your student growing to potential.',
    },
    noComparisonPeriodsMessage: {
        initialText: 'No growth tests available',
        altMessage: 'No achievement tests available',
        helpLinkText: 'Why?',
        helpPopup: {
            helpText:
                'Either there is no prior test or there is no norms data for this subject and grade level (such as 12th grade or 11-12th grade Science). Try choosing a different Term from the menu at top.',
        },
    },
    normsPercentileHelp: {
        initialText:
            'Use the NWEA norms percentiles (a percentage-based ranking) to compare your student’s achievement and growth to matching peers from across the nation (students with same grade, prior RIT, and weeks of instruction between testing). ',
        growth: 'Growth ',
        growthDescription: 'is based on the Comparison Period that you can choose from the top menu. ',
        achievement: 'Achievement ',
        achievementDescription: 'is based on the end term of that Comparison Period.',
    },
    normsPercentileRainbowHelp: {
        initialText: 'NWEA Norms Percentile Color Key',
    },
    growthExpandedHelp: {
        initialText:
            'After you choose a term, set goals in either of the shaded boxes. The graph and other data provide comparisons to help you judge what goal is reasonable.',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=644',
        helpText: ' Tips for Setting Growth Goals ',
        readMoreText: 'Read More: ',
    },
    performanceGoalSettingMessage: 'This student doesn’t have the test scores needed for a growth goal to be set.',
    cgiWarning: {
        highGrowth:
            'This much growth is unusual. If you are sure you want to set a goal this high, please ensure that appropriate supports are in place to make reaching this goal more likely.',
        sortaLowGrowth: 'Many students grow more than this. Consider setting a higher goal for this student.',
        lowGrowth: 'Most students grow more than this. Consider setting a higher goal for this student.',
    },
    goalSettingHelp: {
        paragraph1Text:
            'Enter either the RIT score or growth amount (if applicable), and then click to the side to make your update.',
        paragraph2Text:
            'The graph shows how your goal compares with the NWEA norms percentile bands, with specific norms projections (dotted line), and with college/state linking studies (select checkbox to display).',
        paragraph3StartText: 'When you click ',
        paragraph3SetGoals: 'Set Goals',
        paragraph3Conclusion:
            ', it appears in a row at the top. If needed, you can delete it, or overwrite it by setting a new goal.',
        readMoreText: 'Read More: ',
        helpText: ' Tips for Setting Growth Goals ',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=644',
    },
    goalRitScoreSettingHelp: {
        initialText:
            'Set the RIT score that your student would like to reach, or the target growth amount (if your student has a starting score). Once you change the number, click outside (or press Enter) to see the other numbers updated.',
        paragraph2Text:
            'Compare how your change affects the graph and other data. Adjust as needed to set a goal that is challenging but also realistic.',
        readMoreText: 'Read More: ',
        helpText: ' Tips for Setting Growth Goals ',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=644',
    },
    goalPercentileSettingHelp: {
        initialText:
            'Set the percentile level that your student would like to reach. You can change either number, and click outside (or press Enter) to see the other numbers updated.',
        paragraph2Text:
            'Typically, you start by setting the Achievement Percentile. It is a ranking of NWEA norms test scores for the chosen term, as depicted by colored bands in the graph.',
        paragraph3Text:
            'Next, if your student has a starting score, compare the Growth Percentile your student would have to reach in order to achieve the Achievement Percentile. Higher growth numbers mean a greater challenge. (And if you prefer statistics, compare the Conditional Growth Index, which is used to calculate the Growth Percentile.)',
        readMoreText: 'Read More: ',
        helpText: ' Tips for Setting Growth Goals ',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=644',
    },
    highlights: {
        openHighlights: 'OPEN HIGHLIGHTS',
        closeHighlights: 'CLOSE HIGHLIGHTS',
        showMore: 'SHOW MORE',
        showLess: 'SHOW LESS',
        helpInitialText: 'Use these recommendations to focus your student’s learning in this subject.',
        helpText: 'Highlight Recommendations',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=649',
        readMoreText: 'Read More: ',
    },
    noGoalSettingTerms: 'Because of the student’s grade level, there are no terms left to set a goal.',
    incompleteNormMessage: {
        incompleteNormMessage1:
            '*Norms are not currently provided for this subject/grade/term combination. Review NWEA’s ',
        incompleteNormLink1: 'https://teach.mapnwea.org/impl/NormsTables.pdf',
        incompleteNormLink1Text: 'MAP Normative Data',
        incompleteNormMessage2: ' or ',
        incompleteNormLink2: 'https://www.nwea.org/resources/map-college-readiness-benchmarks/',
        incompleteNormLink2Text: 'College and Career Readiness',
        incompleteNormMessage3: ' studies to assist with determining an appropriate goal for ',
    },
    copyright: {
        copyrightText:
            '© NWEA ' +
            new Date().getFullYear() +
            '. MAP is a registered trademark. NWEA, MAP Growth and MAP Skills are trademarks of NWEA in the U.S. and in other countries.',
        commonCore:
            'Common Core Standards (if included) used under license. © Copyright 2010. National Governors Association Center for Best Practices and Council of Chief State School Officers. All rights reserved.',
        science:
            'Next Generation Science Standards (if included) used under license. NGSS Lead States. 2013. Next Generation Science Standards: For States, By States. Washington, DC: The National Academies Press.',
        columbiaText:
            'Next Generation Science Standards is a registered trademark of Achieve. Neither Achieve nor the lead states and partners that developed the Next Generation Science Standards were involved in the production of this product and do not endorse it. 2013 District of Columbia K-12 Science Standards (if included) adopting the Next Generation Science Standards 2013.',
        virginiaText: `
        Virginia Standards of Learning © 2024 by the Commonwealth of Virginia Department of Education. All rights reserved. Reproduced by permission.
        The Virginia Department of Education is the sole copyright owner of the material and reserves all rights to the material, including, but not limited, to the rights to reprint, reproduce, transmit, copy, or distribute the material.
        `,
        virginiaText1: `
        Virginia Standards of Learning © 2023 by the Commonwealth of Virginia Department of Education. All rights reserved. Reproduced by permission. 
        The Virginia Department of Education is the sole copyright owner of the material and reserves all rights to the material, including, but not limited, to the rights to reprint, reproduce, transmit, copy, or distribute the material.
        `,
        virginiaBulletPoint1:`A third party who wishes to use the material in any manner must contact the Virginia Department of Education for specific written permission unless that party falls within one of the exceptions specified in the agency’s policy.`,
        virginiaBulletPoint2:`Any materials requested that contain copyrighted information from other parties may not be used without the expressed written consent of the person or entity that owns the copyright.`,
        virginiaBulletPoint3:`Use of these materials does not represent an endorsement or review of the product, curriculum, or materials by the Virginia Department of Education.`,
        lexile: `* Lexile® and Quantile® are trademarks of MetaMetrics, Inc., and are registered in the United States and abroad. The trademarks and names of other companies and products mentioned herein are the property of their respective owners. Copyright © ${new Date().getFullYear()} MetaMetrics, Inc. All rights reserved.`,
        userNormFooter:
            '\u00B9User norms are based on the group of students who have taken the test in the selected subject and course. These results are not comparable to results based on nationally representative norms.',
        confidentiality:
            'CONFIDENTIALITY NOTICE:  This information may be confidential and legally protected from disclosure.',
    },
    gotHelp: {
        paragraph1Text:
            'Evaluate how your student has grown over prior terms (fall, winter, and spring only). To see further back, change the',
        paragraph2Text: ' Term',
        paragraph3Text: ' menu, above the student name. Basic graph features:',
        readMoreText: 'Read More: ',
        helpText: 'Growth Over Time',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=648',
    },
    gotMissingTerms: {
        helpBoxTitle: 'Future Terms',
        helpBoxText:
            'Future academic years must be set up in the MAP system before we can calculate projected scores or save growth goals to them. Please ask a leader or administrator to add the next year within the MAP preferences.',
        labelMessage: 'Some future terms are not yet setup in the system.',
    },
    instructionalAreasExpandedHelp: {
        initialText:
            'Use these learning statements and standards to develop a learning path for your student. Features include:',
        standardText: `view to see applicable state standards (also pick your student's grade)`,
        filtersText: ' to focus on a particular topic',
        reinforceText: ' for remediation or ',
        introduceText: ' for enrichment',
        readMoreText: 'Read More: ',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=647',
        helpLinkText: 'Tips for Learning Paths ',
    },
    instructionalAreasFilterHelp: {
        mainHeader: 'Learning Statements Help',
        initialText: 'Choose the type of learning statements that would help your student grow:',
        reinforceHead: 'Reinforce*',
        reinforceText:
            'Taken from the next lower RIT band. Student likely knows these skills and concepts, so you can reinforce and connect them with new learning.',
        developHead: 'Develop',
        developText: 'Taken from the student’s current RIT band. Student is ready to work on these now.',
        introduceHead: 'Introduce*',
        introduceText:
            'Taken from the next higher RIT band. You could introduce them when the student is ready for more challenge.',
        mainFooter: {
            openingText:
                '*   Focus on the dark gray statements. Lighter gray statements already show under Develop (the same concept applies across ',
            underlinedText: 'RIT ranges',
            closingText: ').',
        },
        readMoreText: 'Read More: ',
        helpLink: 'https://teach.mapnwea.org/assist/help_map/ApplicationHelp.htm#cshid=647',
        helpLinkText: 'Tips for Learning Paths ',
    },
    printAndShareHelp: {
        printScreen: 'Print the current screen.',
        batchPDF: 'Select subjects, pages, students, and other settings for a combined PDF report.',
        familyBatchPDF: 'Select subjects, students, and other settings for a combined PDF Family Report.',
        selectPages: 'Choose any combination of information to include with each student’s report:',
    },
    disengagement: {
        disengagementPercentage: 'Rapid-Guessing %',
        impactOfDisengagement: 'Est. Impact of Rapid-Guessing % on RIT',
    },
    unsupportedTestEventsHelp: {
        initialText:
            'Course-specific assessment results are not currently available in Student Profile. Please use Class Report or Achievement Status and Growth Report.',
        goToClassReport: 'Go to Class Report.',
    },
};